import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  color?: Color;
  size?: Unit;
};

export const InSeason2026 = ({ size = 2, color }: Props) => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 51 32"
      style={{ height: unitMapping[size] }}
    >
      <linearGradient
        id={id}
        gradientUnits="userSpaceOnUse"
        x1="-0.4229"
        y1="14.3909"
        x2="51.4242"
        y2="17.6092"
      >
        <stop offset="0" style={{ stopColor: '#F8D3DA' }} />
        <stop offset="0.2832" style={{ stopColor: '#B3A9F4' }} />
        <stop offset="0.5401" style={{ stopColor: '#FBE9FB' }} />
        <stop offset="1" style={{ stopColor: '#4F94FD' }} />
      </linearGradient>
      <path
        d="M36.7,15.7h-5.9v9.9h5.9V15.7z M8.1,0L0,7.6V32h41.6l9.4-7.5V0H8.1L8.1,0z M23.2,14.1L14,20.7v4.8h9.2v2.8H10.4
   v-9l9.2-6.5v-7H14v5.6h-3.6V7.5c0-3.2,1.8-4.7,6.4-4.7s6.4,1.5,6.4,4.7L23.2,14.1L23.2,14.1z M40.3,10.8h-3.6V5.6h-5.9v8.9
   c1-1.1,2.7-1.7,4.7-1.7c2.9,0,4.8,1.4,4.8,4.4v6.4c0,3.2-1.9,4.7-6.6,4.7c-4.7,0-6.6-1.5-6.6-4.7V7.4c0-3.2,2-4.7,6.6-4.7
   s6.6,1.5,6.6,4.7L40.3,10.8L40.3,10.8z"
        fill={color || `url(#${id})`}
      />
    </svg>
  );
};

export const InSeason2027 = ({ size = 2, color }: Props) => {
  const id = useId();
  return (
    <svg
      style={{ height: unitMapping[size] }}
      viewBox="0 0 24.2148 15.4062"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id={id}
        gradientUnits="userSpaceOnUse"
        x1="-0.4229"
        y1="14.3909"
        x2="51.4242"
        y2="17.6092"
      >
        <stop offset="0" style={{ stopColor: '#F8D3DA' }} />
        <stop offset="0.2832" style={{ stopColor: '#B3A9F4' }} />
        <stop offset="0.5401" style={{ stopColor: '#FBE9FB' }} />
        <stop offset="1" style={{ stopColor: '#4F94FD' }} />
      </linearGradient>
      <path
        d="M24.2148 11.7764L19.7725 15.4062H0V3.63867L3.83301 0H24.2148V11.7764ZM8.9375 1.48047C6.7968 1.48047 5.91423 2.16677 5.91406 3.73535V5.51758H7.59766V2.83691H10.2773V6.1709L5.91406 9.27637V13.5088H11.9609V12.2178H7.59766V9.92969L11.9609 6.80859V3.73535C11.9608 2.16682 11.078 1.48051 8.9375 1.48047ZM13.2236 1.5791V2.88672H17.2109L14.2041 13.5088H15.9688L18.9922 2.88672V1.5791H13.2236Z"
        fill={color || `url(#${id})`}
      />
    </svg>
  );
};
